module.exports = __webpack_public_path__ + "media/virtualStagingContractMedia/virtualStagingMedia2-7bd4fe52.jpeg";